import React from 'react';
import PropTypes from 'prop-types';

import { Chip as MUIChip } from '@material-ui/core';

export const Chip = props => <MUIChip {...props} />;

Chip.propTypes = {
  avatar: PropTypes.node,
  classes: PropTypes.object,
  clickable: PropTypes.bool,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  deleteIcon: PropTypes.node,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.node,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']),
  style: PropTypes.object,
  variant: PropTypes.oneOf(['default', 'outlined'])
};

export default Chip;
